import React from "react";
import { QuoteIcon, StarIcon } from "lucide-react";
import { testimonials } from "../data/testimonials";
import { SectionHeading } from "./SectionHeading";
export function TestimonialsSection() {
  return <section className="bg-white py-16 md:py-24" data-id="element-300" data-mp="1n0tvax7gxfa4">
      <div className="wrap" data-id="element-301" data-mp="1my7rn8np7jx6">
        <SectionHeading eyebrow="Lo que dicen quienes la usan" title={<>
              Emprendedores que ya <span className="text-gold-dark" data-id="element-303" data-mp="1d134b5i49ies">muestran mejor</span>
            </>} data-id="element-302" data-mp="1r142ueawsdr3" />
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-304" data-mp="1i1qrth74zh49">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-line bg-white p-6 shadow-[0_10px_30px_rgba(20,39,85,0.06)] md:p-7" data-id="element-305" data-mp="142hm5bgk45ej">
              <div className="flex items-center justify-between" data-id="element-306" data-mp="2ygilryjxkwfo">
                <div className="flex gap-0.5 text-gold-dark" aria-label="5 de 5 estrellas" data-id="element-307" data-mp="32gj2xqyezlqf">
                  {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-308" data-mp="2uzzvou5egivs" />)}
                </div>
                <QuoteIcon className="h-6 w-6 text-gold-cream" aria-hidden="true" data-id="element-309" data-mp="2q0n8g8am99so" />
              </div>
              <blockquote className="mt-4 flex-1 italic text-ink" data-id="element-310" data-mp="2zsaws0bvmapx">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-5" data-id="element-311" data-mp="2zunce6u5w8zt">
                <img src={t.photo} alt="" loading="lazy" className="h-12 w-12 rounded-full object-cover" data-id="element-312" data-mp="2c4t31z91x2kb" />
                <div data-id="element-313" data-mp="275zy4v7tyjvr">
                  <strong className="block text-ink" data-id="element-314" data-mp="2m1fjmbuch7gj">{t.name}</strong>
                  <span className="text-sm text-muted" data-id="element-315" data-mp="2lyjlonihyis3">{t.business}</span>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}